import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import NewsPage from './pages/NewsPage';
import NewsDetailPage from './pages/NewsDetailPage';
import SandaTourPage from './pages/SandaTourPage';
import { initGA, trackPageView } from './utils/analytics';
import NotFoundPage from './pages/NotFoundPage';


// ページビュー追跡用コンポーネント
function AnalyticsWrapper({ children }) {
  const location = useLocation();

  useEffect(() => {
    // ページタイトルを取得
    const getPageTitle = (pathname) => {
      switch(pathname) {
        case '/':
          return '株式会社J・T・C - 旅人倶楽部';
        case '/about':
          return '会社情報 | 株式会社J・T・C';
        case '/news':
          return '新着情報 | 株式会社J・T・C';
        case '/sanda-tougei-no-mori-tour2025':
          return '三田陶芸の森 特別ツアー ';
        default:
          if (pathname.startsWith('/news/')) {
            const newsId = pathname.split('/news/')[1];
            return `ニュース詳細 ${newsId} | 株式会社J・T・C`;
          }
          return '株式会社J・T・C';
      }
    };

    // ページビュー追跡
    trackPageView(location.pathname, getPageTitle(location.pathname));
    
    // ページ上部にスクロール
    window.scrollTo(0, 0);
  }, [location]);

  return children;
}

// レイアウトコンポーネント（Header/Footerを含む）
function LayoutWrapper({ children }) {
  const location = useLocation();
  
  // SandaTourPageではHeader/Footerを表示しない
  const hideLayout = location.pathname === '/sanda-tougei-no-mori-tour2025';
  
  if (hideLayout) {
    return children;
  }
  
  return (
    <>
      <Header />
      <main style={{ marginTop: '70px' }}>
        {children}
      </main>
      <Footer />
    </>
  );
}

function App() {
  // Google Analytics初期化（アプリ起動時に一度だけ実行）
  useEffect(() => {
    initGA();
  }, []);

  return (
    <Router>
      <div className="App">
        <AnalyticsWrapper>
          <LayoutWrapper>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/news/:id" element={<NewsDetailPage />} />
              <Route path="/sanda-tougei-no-mori-tour2025" element={<SandaTourPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </LayoutWrapper>
        </AnalyticsWrapper>
      </div>
    </Router>
  );
}

export default App;